import {
  DistributionChannel,
  NotificationsUserSettingsInputModel,
  NotificationsUserSettingsViewModel,
} from '@ail/notifications-api'
import { PermissionsEnum } from '../../../../../types/enums'

export type ChannelSettingKey =
  | 'enabledChannelsForApprovalProcessesNotifications'
  | 'enabledChannelsForRequestsNotifications'
  | 'enabledChannelsForReportsNotifications'

export type NotificationChannelsState = Record<ChannelSettingKey, DistributionChannel[]>

export const ALL_CHANNELS: DistributionChannel[] = [DistributionChannel.Native, DistributionChannel.Email]

export const DefaultChannels: NotificationChannelsState = {
  enabledChannelsForApprovalProcessesNotifications: ALL_CHANNELS,
  enabledChannelsForRequestsNotifications: ALL_CHANNELS,
  enabledChannelsForReportsNotifications: ALL_CHANNELS,
}

export const toggleChannel = (channels: DistributionChannel[], channel: DistributionChannel): DistributionChannel[] =>
  channels.includes(channel) ? channels.filter((c) => c !== channel) : [...channels, channel]

export const buildSettingsInputModel = (
  channels: NotificationChannelsState,
  settings?: NotificationsUserSettingsViewModel
): NotificationsUserSettingsInputModel | undefined => {
  if (!settings) return
  return { ...settings, ...channels }
}

// Derived local values for keys that use BE namings. If BE changes, need to update this config too.
export const SETTINGS: {
  key: ChannelSettingKey
  labelKey: string
  icon: string
  requiredPermission: PermissionsEnum | null
}[] = [
  {
    key: 'enabledChannelsForRequestsNotifications',
    labelKey: 'REQUESTS',
    icon: 'icon-requests',
    requiredPermission: PermissionsEnum.OrdersManage,
  },
  {
    key: 'enabledChannelsForApprovalProcessesNotifications',
    labelKey: 'APPROVAL_STEPS_FOR_REQUESTS',
    icon: 'icon-check',
    requiredPermission: PermissionsEnum.RequestsApprove,
  },
  {
    key: 'enabledChannelsForReportsNotifications',
    labelKey: 'REPORTS',
    icon: 'icon-report',
    requiredPermission: PermissionsEnum.ReportsView,
  },
]
